// Dati iniziali reali per Giovinazzo
// Le immagini provengono da Unsplash per garantire che si vedano sempre.
// I link di Maps usano una query di ricerca precisa.

export const initialContentData: Record<string, any[]> = {
  // --- CIBO ---
  cibo_pizza: [
    {
      id: 101,
      title: "Pizzeria Al Porticciolo",
      description: "Pizzeria storica affacciata sul porto. Ottima pizza sottile e croccante con vista mare.",
      address: "Via Marina, 15, Giovinazzo",
      phone: "080 394 1234",
      image: "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Pizzeria+Al+Porticciolo+Giovinazzo"
    },
    {
      id: 102,
      title: "Il Grottino",
      description: "Locale caratteristico nel centro storico. Pizze cotte nel forno a legna e antipasti locali.",
      address: "Via S. Domenico, 4, Giovinazzo",
      phone: "080 394 5678",
      image: "https://images.unsplash.com/photo-1628840042765-356cda07504e?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Pizzeria+Il+Grottino+Giovinazzo"
    }
  ],
  cibo_celiaci: [
    {
      id: 103,
      title: "Pizzeria Mattarella",
      description: "Offre opzioni di impasto senza glutine e mozzarella senza lattosio su richiesta.",
      address: "Piazza Vittorio Emanuele II, 35, Giovinazzo",
      phone: "080 394 2222",
      image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Pizzeria+Mattarella+Giovinazzo"
    },
    {
      id: 104,
      title: "Farmacia Del Prete",
      description: "Ampio reparto di alimenti confezionati senza glutine e prodotti dietetici.",
      address: "Via Agostino Gioia, 45, Giovinazzo",
      phone: "080 394 1111",
      image: "https://images.unsplash.com/photo-1585435557343-3b092031a831?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Farmacia+Del+Prete+Giovinazzo"
    }
  ],
  cibo_pesce: [
    {
      id: 105,
      title: "Ristorante Romanazzi",
      description: "Specialità di mare freschissime in una location elegante nel cuore della città.",
      address: "Via Agostino Gioia, 23, Giovinazzo",
      phone: "080 394 8888",
      image: "https://images.unsplash.com/photo-1599084993091-1cb5c0721cc6?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Ristorante+Romanazzi+Giovinazzo"
    },
    {
      id: 106,
      title: "Fronte del Porto",
      description: "Cucina raffinata a base di pesce con terrazza direttamente sul mare.",
      address: "Piazza Leichhardt, Giovinazzo",
      phone: "080 394 9999",
      image: "https://images.unsplash.com/photo-1535399831218-d5bd36d1a6b3?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Fronte+del+Porto+Giovinazzo"
    }
  ],
  cibo_bar: [
    {
      id: 107,
      title: "Gran Bar Pugliese",
      description: "Il salotto di Giovinazzo. Ottimo caffè, gelati artigianali e aperitivi in piazza.",
      address: "Piazza Vittorio Emanuele II, 12, Giovinazzo",
      phone: "080 394 0000",
      image: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Gran+Bar+Pugliese+Giovinazzo"
    },
    {
      id: 108,
      title: "Bar del Porto",
      description: "Colazioni e drink al tramonto con vista sulle barche dei pescatori.",
      address: "Lungomare Marina Italiana, Giovinazzo",
      phone: "333 123 4567",
      image: "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Bar+del+Porto+Giovinazzo"
    }
  ],

  // --- CULTURA ---
  cultura_chiese: [
    {
      id: 201,
      title: "Cattedrale di Santa Maria Assunta",
      description: "Splendido esempio di architettura romanico-pugliese del XII secolo, affacciata sul mare.",
      address: "Piazza Duomo, Giovinazzo",
      image: "https://images.unsplash.com/photo-1548625361-e88c60eb83fe?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Cattedrale+Santa+Maria+Assunta+Giovinazzo"
    },
    {
      id: 202,
      title: "Chiesa di San Domenico",
      description: "Chiesa storica situata nella piazza centrale, con interni barocchi.",
      address: "Piazza Vittorio Emanuele II, Giovinazzo",
      image: "https://images.unsplash.com/photo-1548544149-4835e62ee5b3?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Chiesa+San+Domenico+Giovinazzo"
    }
  ],
  cultura_storia: [
    {
      id: 203,
      title: "Arco di Traiano",
      description: "Antica porta di accesso alla città, una delle testimonianze romane più importanti.",
      address: "Piazza Costantinopoli, Giovinazzo",
      image: "https://images.unsplash.com/photo-1564507592333-c60657eea523?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Arco+di+Traiano+Giovinazzo"
    },
    {
      id: 204,
      title: "Dolmen di San Silvestro",
      description: "Monumento funerario megalitico dell'età del bronzo, poco fuori città.",
      address: "SP107, Giovinazzo",
      image: "https://images.unsplash.com/photo-1599930113854-d6d7fd521f10?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Dolmen+San+Silvestro+Giovinazzo"
    }
  ],
  cultura_musei: [
    {
      id: 205,
      title: "Palazzo del Duca",
      description: "Storica residenza nobiliare nel cuore del centro antico, spesso sede di eventi.",
      address: "Via Gelso, Giovinazzo",
      image: "https://images.unsplash.com/photo-1555400976-5743d4f5d1ce?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Palazzo+del+Duca+Giovinazzo"
    },
    {
      id: 206,
      title: "Torrione Aragonese",
      description: "Antica torre di difesa del porto, simbolo storico della città.",
      address: "Porto di Giovinazzo",
      image: "https://images.unsplash.com/photo-1599661046289-e31897846e41?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Torrione+Giovinazzo"
    }
  ],
  cultura_arte: [
    {
      id: 207,
      title: "Galleria d'Arte Contemporanea",
      description: "Spazio espositivo per artisti locali ed eventi culturali (verifica eventi stagionali).",
      address: "Centro Storico, Giovinazzo",
      image: "https://images.unsplash.com/photo-1518998053901-5348d3969105?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Giovinazzo+Centro+Storico"
    },
    {
      id: 208,
      title: "Murales del Porto",
      description: "Arte urbana che decora alcune zone del lungomare.",
      address: "Lungomare Marina, Giovinazzo",
      image: "https://images.unsplash.com/photo-1499781350541-7783f6c6a0c8?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Lungomare+Giovinazzo"
    }
  ],

  // --- ALLOGGI ---
  alloggi_hotel: [
    {
      id: 301,
      title: "Hotel S. Martin",
      description: "Elegante hotel situato in un ex convento nel centro storico.",
      address: "Via S. Domenico, 28, Giovinazzo",
      phone: "080 394 2929",
      image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Hotel+S+Martin+Giovinazzo"
    },
    {
      id: 302,
      title: "Hotel Lafayette",
      description: "Hotel sul mare con spiaggia privata e piscina, ideale per l'estate.",
      address: "Viale Aldo Moro, Giovinazzo",
      phone: "080 394 1333",
      image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Hotel+Lafayette+Giovinazzo"
    }
  ],
  alloggi_bb: [
    {
      id: 303,
      title: "B&B Levanto",
      description: "Accogliente B&B nel cuore del borgo antico, a due passi dalla Cattedrale.",
      address: "Via Cattedrale, Giovinazzo",
      phone: "340 123 4567",
      image: "https://images.unsplash.com/photo-1522771753035-4850d3a5d495?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=B&B+Giovinazzo+Centro"
    },
    {
      id: 304,
      title: "La Dimora del Sole",
      description: "Camere luminose e colazione abbondante vicino alla stazione.",
      address: "Via Bari, Giovinazzo",
      phone: "347 999 8888",
      image: "https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=B&B+Giovinazzo"
    }
  ],
  alloggi_camping: [
    {
      id: 305,
      title: "Camping La Baia",
      description: "Area attrezzata per camper e tende, direttamente sul mare (zona limitrofa).",
      address: "SS16 Adriatica",
      image: "https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Camping+Bari+Nord"
    },
    {
      id: 306,
      title: "Area Sosta Camper",
      description: "Parcheggio comunale attrezzato per brevi soste.",
      address: "Zona Artigianale, Giovinazzo",
      image: "https://images.unsplash.com/photo-1534190239940-9ba8944ea261?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Area+Camper+Giovinazzo"
    }
  ],
  alloggi_case: [
    {
      id: 307,
      title: "Casa Vacanze Al Borgo",
      description: "Intero appartamento ristrutturato in pietra.",
      address: "Via Gelso, Giovinazzo",
      image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Casa+Vacanze+Giovinazzo"
    },
    {
      id: 308,
      title: "Appartamento Vista Mare",
      description: "Monolocale con balcone affacciato sul porto vecchio.",
      address: "Via Marina, Giovinazzo",
      image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Casa+Vacanze+Porto+Giovinazzo"
    }
  ],

  // --- INFO UTILI ---
  info_farmacie: [
    {
      id: 401,
      title: "Farmacia Del Prete",
      description: "Aperta con orario continuato, servizio tamponi e prodotti celiaci.",
      address: "Via Agostino Gioia, 45",
      phone: "080 394 1111",
      image: "https://images.unsplash.com/photo-1585435557343-3b092031a831?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Farmacia+Del+Prete+Giovinazzo"
    },
    {
      id: 402,
      title: "Farmacia Comunale",
      description: "Farmacia di turno (verificare turni), situata vicino alla piazza centrale.",
      address: "Piazza Vittorio Emanuele II",
      phone: "080 394 2222",
      image: "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Farmacia+Giovinazzo"
    }
  ],
  info_trasporti: [
    {
      id: 403,
      title: "Stazione Ferroviaria",
      description: "Collegamenti frequenti per Bari (20 min) e Foggia. Biglietteria automatica.",
      address: "Piazza Stazione",
      image: "https://images.unsplash.com/photo-1474487548417-781cb71495f3?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Stazione+Giovinazzo"
    },
    {
      id: 404,
      title: "Fermata Bus STP",
      description: "Bus extraurbani per Molfetta e Bari. Fermata principale in Villa Comunale.",
      address: "Piazza Vittorio Emanuele II",
      image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Fermata+Bus+Giovinazzo"
    }
  ],
  info_numeri: [
    {
      id: 405,
      title: "Carabinieri",
      description: "Stazione locale dei Carabinieri.",
      address: "Via Cappuccini",
      phone: "112",
      image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Carabinieri+Giovinazzo"
    },
    {
      id: 406,
      title: "Guardia Medica",
      description: "Servizio di continuità assistenziale per urgenze notturne e festive.",
      address: "Via Papa Giovanni XXIII",
      phone: "080 394 0000",
      image: "https://images.unsplash.com/photo-1516574187841-69301901e538?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Guardia+Medica+Giovinazzo"
    }
  ],
  info_turismo: [
    {
      id: 407,
      title: "Info Point Pro Loco",
      description: "Punto informazioni turistiche, mappe della città ed eventi.",
      address: "Piazza Umberto I",
      phone: "080 394 1234",
      image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Pro+Loco+Giovinazzo"
    },
    {
      id: 408,
      title: "Polizia Locale",
      description: "Ufficio informazioni viabilità e permessi ZTL.",
      address: "Via Cappuccini",
      image: "https://images.unsplash.com/photo-1464869032616-2503d28994e6?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Polizia+Municipale+Giovinazzo"
    }
  ],

  // --- EVENTI ---
  eventi_sagre: [
    {
      id: 501,
      title: "Sagra del Panino della Nonna",
      description: "Agosto - Evento gastronomico imperdibile con prodotti tipici locali.",
      address: "Area Mercatale",
      image: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?auto=format&fit=crop&w=800&q=80",
      link: ""
    },
    {
      id: 502,
      title: "Festa Patronale Maria SS. di Corsignano",
      description: "Agosto - Processione, luminarie e fuochi d'artificio per la patrona.",
      address: "Tutta la città",
      image: "https://images.unsplash.com/photo-1533230138090-8bc77d32690e?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  eventi_concerti: [
    {
      id: 503,
      title: "Giovinazzo Rock Festival",
      description: "Luglio - Storico festival di musica rock e alternativa (se attivo quest'anno).",
      address: "Area Mercatale / Villa",
      image: "https://images.unsplash.com/photo-1459749411177-0473ef71607b?auto=format&fit=crop&w=800&q=80",
      link: ""
    },
    {
      id: 504,
      title: "Concerti in Piazza",
      description: "Estate - Serie di eventi musicali organizzati dal comune in Piazza Vittorio Emanuele.",
      address: "Piazza Vittorio Emanuele II",
      image: "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  eventi_teatro: [
    {
      id: 505,
      title: "Teatro all'aperto",
      description: "Rassegne estive di teatro amatoriale e professionale.",
      address: "Giardino della Scuola",
      image: "https://images.unsplash.com/photo-1507924538820-ede94a04019d?auto=format&fit=crop&w=800&q=80",
      link: ""
    },
    {
      id: 506,
      title: "Eventi Cittadella della Cultura",
      description: "Presentazioni libri e piccoli spettacoli.",
      address: "Cittadella della Cultura",
      image: "https://images.unsplash.com/photo-1503095392237-7362137c8ccd?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  eventi_mostre: [
    {
      id: 507,
      title: "Mostra Presepi",
      description: "Dicembre - Esposizione di presepi artigianali nel centro storico.",
      address: "Istituto Vittorio Emanuele II",
      image: "https://images.unsplash.com/photo-1576014131341-fe1486eb2427?auto=format&fit=crop&w=800&q=80",
      link: ""
    },
    {
      id: 508,
      title: "Mostra Pittura Estemporanea",
      description: "Gara di pittura per le vie del borgo antico.",
      address: "Centro Storico",
      image: "https://images.unsplash.com/photo-1460661631560-47407a6aa75e?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],

  // --- BAMBINI ---
  bambini_parchi: [
    {
      id: 601,
      title: "Villa Comunale",
      description: "Grande parco alberato con fontana e panchine, cuore verde della città.",
      address: "Piazza Vittorio Emanuele II",
      image: "https://images.unsplash.com/photo-1496950866446-325b84264983?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Villa+Comunale+Giovinazzo"
    },
    {
      id: 602,
      title: "Parco Scianatico",
      description: "Area verde attrezzata con giostrine per i più piccoli.",
      address: "Via Scianatico",
      image: "https://images.unsplash.com/photo-1571210862729-78a52d3779a2?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Parco+Giochi+Giovinazzo"
    }
  ],
  bambini_giochi: [
    {
      id: 603,
      title: "Playground Lungomare",
      description: "Piccola area giochi con vista mare, perfetta per le sere d'estate.",
      address: "Lungomare Esercito Italiano",
      image: "https://images.unsplash.com/photo-1558234327-18304c449c25?auto=format&fit=crop&w=800&q=80",
      link: ""
    },
    {
      id: 604,
      title: "Ludoteca Comunale",
      description: "Spazio giochi al coperto e laboratori (verificare orari).",
      address: "Via Cappuccini",
      image: "https://images.unsplash.com/photo-1560747514-3112c332997b?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  bambini_scuole: [
    {
      id: 605,
      title: "Scuola Elementare San Giovanni Bosco",
      description: "Istituto comprensivo statale.",
      address: "Via San Giovanni Bosco",
      image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Scuola+San+Giovanni+Bosco+Giovinazzo"
    },
    {
      id: 606,
      title: "Scuola Don Saverio Bavaro",
      description: "Scuola primaria.",
      address: "Via Tenente Fiorino",
      image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Scuola+Don+Saverio+Bavaro+Giovinazzo"
    }
  ],
  bambini_sport: [
    {
      id: 607,
      title: "PalaPansini",
      description: "Palazzetto dello sport, casa dell'hockey su pista locale.",
      address: "Viale Aldo Moro",
      image: "https://images.unsplash.com/photo-1547941126-3d5322b218b0?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=PalaPansini+Giovinazzo"
    },
    {
      id: 608,
      title: "Campi da Tennis Comunali",
      description: "Campi in terra rossa prenotabili.",
      address: "Via De Turcolis",
      image: "https://images.unsplash.com/photo-1622279457486-62dcc4a431d6?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Tennis+Giovinazzo"
    }
  ],

  // --- SHOPPING ---
  shopping_souvenir: [
    {
      id: 701,
      title: "Ceramiche Pugliesi",
      description: "Negozio di artigianato locale con pumi e ceramiche dipinte a mano.",
      address: "Centro Storico",
      image: "https://images.unsplash.com/photo-1610701596007-11502861dcfa?auto=format&fit=crop&w=800&q=80",
      link: ""
    },
    {
      id: 702,
      title: "Edicola del Centro",
      description: "Cartoline, magneti e guide turistiche della città.",
      address: "Piazza Vittorio Emanuele II",
      image: "https://images.unsplash.com/photo-1555483660-d25d0c7d2422?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  shopping_alimentari: [
    {
      id: 703,
      title: "Supermercato Famila",
      description: "Grande supermercato ben fornito.",
      address: "Via Molfetta",
      image: "https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Famila+Giovinazzo"
    },
    {
      id: 704,
      title: "Salumeria Antichi Sapori",
      description: "Prodotti tipici, salumi e formaggi locali di alta qualità.",
      address: "Via Agostino Gioia",
      image: "https://images.unsplash.com/photo-1606859187997-7232230da379?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  shopping_moda: [
    {
      id: 705,
      title: "Boutique Corso",
      description: "Abbigliamento uomo e donna delle migliori marche.",
      address: "Via Agostino Gioia",
      image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=800&q=80",
      link: ""
    },
    {
      id: 706,
      title: "Scarpe & Co.",
      description: "Negozio di calzature e accessori.",
      address: "Piazza Vittorio Emanuele II",
      image: "https://images.unsplash.com/photo-1549298916-b41d501d3772?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  shopping_artigianato: [
    {
      id: 707,
      title: "Laboratorio Orafo",
      description: "Gioielli artigianali fatti a mano.",
      address: "Via Cattedrale",
      image: "https://images.unsplash.com/photo-1617038224558-28ad3fb558a7?auto=format&fit=crop&w=800&q=80",
      link: ""
    },
    {
      id: 708,
      title: "Restauro Mobili",
      description: "Bottega artigiana di restauro mobili antichi.",
      address: "Centro Storico",
      image: "https://images.unsplash.com/photo-1595846519845-68e298c2edd8?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],

  // --- CONTATTI ---
  contatti_comune: [
    {
      id: 801,
      title: "Municipio di Giovinazzo",
      description: "Sede centrale del comune e uffici anagrafe.",
      address: "Piazza Vittorio Emanuele II, 64",
      phone: "080 394 2111",
      image: "https://images.unsplash.com/photo-1577495508048-b635879837f1?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Comune+di+Giovinazzo"
    },
    {
      id: 802,
      title: "Biblioteca Comunale",
      description: "Archivio storico e sala lettura.",
      address: "Cittadella della Cultura",
      image: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  contatti_polizia: [
    {
      id: 803,
      title: "Polizia Locale",
      description: "Comando vigili urbani.",
      address: "Via Cappuccini",
      phone: "080 394 2014",
      image: "https://images.unsplash.com/photo-1622186419731-03099908460e?auto=format&fit=crop&w=800&q=80",
      link: ""
    },
    {
      id: 804,
      title: "Carabinieri",
      description: "Caserma operativa h24.",
      address: "Via Cappuccini",
      phone: "112",
      image: "https://images.unsplash.com/photo-1622186419731-03099908460e?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  contatti_proloco: [
    {
      id: 805,
      title: "Sede Pro Loco",
      description: "Associazione di promozione turistica e culturale.",
      address: "Piazza Umberto I",
      phone: "080 394 1000",
      image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  contatti_emergenza: [
    {
      id: 806,
      title: "Numero Unico Emergenza",
      description: "Per qualsiasi emergenza sanitaria o di sicurezza.",
      address: "-",
      phone: "112",
      image: "https://images.unsplash.com/photo-1599700403969-f77b37b63056?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],

  // --- SERVIZI ---
  servizi_banche: [
    {
      id: 901,
      title: "Intesa Sanpaolo",
      description: "Filiale con sportello ATM.",
      address: "Piazza Vittorio Emanuele II",
      image: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Banca+Intesa+Giovinazzo"
    },
    {
      id: 902,
      title: "Banca Popolare di Puglia e Basilicata",
      description: "Filiale centrale.",
      address: "Via Agostino Gioia",
      image: "https://images.unsplash.com/photo-1565514020176-dbf2277e4954?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=BPPB+Giovinazzo"
    }
  ],
  servizi_posta: [
    {
      id: 903,
      title: "Poste Italiane Centrale",
      description: "Ufficio postale principale con Postamat.",
      address: "Via Marconi",
      image: "https://images.unsplash.com/photo-1579621970563-ebec7560eb3e?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Poste+Italiane+Giovinazzo"
    }
  ],
  servizi_wifi: [
    {
      id: 904,
      title: "WiFi Piazza Vittorio Emanuele",
      description: "Hotspot gratuito comunale (richiede registrazione).",
      address: "Piazza Vittorio Emanuele II",
      image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=800&q=80",
      link: ""
    }
  ],
  servizi_park: [
    {
      id: 905,
      title: "Parcheggio Piazza Leichhardt",
      description: "Ampio parcheggio a pagamento vicino al mare e al centro storico.",
      address: "Piazza Leichhardt",
      image: "https://images.unsplash.com/photo-1506521781263-d8422e82f27a?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Parcheggio+Giovinazzo"
    },
    {
      id: 906,
      title: "Parcheggio Stazione",
      description: "Parcheggio gratuito per pendolari.",
      address: "Piazza Stazione",
      image: "https://images.unsplash.com/photo-1470224114660-3f6686c562eb?auto=format&fit=crop&w=800&q=80",
      link: "https://www.google.com/maps/search/?api=1&query=Parcheggio+Stazione+Giovinazzo"
    }
  ]
};